import { CountryISO } from './country-iso.enum';

export enum CountryPhoneCodeEnum {
  C54 = <any>CountryISO.Argentina,
  C591 = <any>CountryISO.Bolivia,
  C55 = <any>CountryISO.Brazil,
  C56 = <any>CountryISO.Chile,
  C57 = <any>CountryISO.Colombia,
  C502 = <any>CountryISO.Guatemala,
  C52 = <any>CountryISO.Mexico,
  C595 = <any>CountryISO.Paraguay,
  C51 = <any>CountryISO.Peru,
  C59 = <any>CountryISO.Uruguay,

  C1242 = <any>CountryISO.Bahamas,

  C685 = <any>CountryISO.Samoa,

  C20 = <any>CountryISO.Egypt,
  C211 = <any>CountryISO.SouthSudan,
  C212 = <any>CountryISO.Morocco,
  C213 = <any>CountryISO.Algeria,
  C216 = <any>CountryISO.Tunisia,
  C218 = <any>CountryISO.LibyanArabJamahiriya,
  C220 = <any>CountryISO.Gambia,
  C221 = <any>CountryISO.Senegal,
  C222 = <any>CountryISO.Mauritania,
  C223 = <any>CountryISO.Mali,
  C224 = <any>CountryISO.Guinea,
  C225 = <any>CountryISO.CoteDivoire,
  C226 = <any>CountryISO.BurkinaFaso,
  C227 = <any>CountryISO.Niger,
  C228 = <any>CountryISO.Togo,
  C229 = <any>CountryISO.Benin,
  C230 = <any>CountryISO.Mauritius,
  C231 = <any>CountryISO.Liberia,
  C232 = <any>CountryISO.SierraLeone,
  C233 = <any>CountryISO.Ghana,
  C234 = <any>CountryISO.Nigeria,
  C235 = <any>CountryISO.Chad,
  C236 = <any>CountryISO.CentralAfricanRepublic,
  C237 = <any>CountryISO.Cameroon,
  C238 = <any>CountryISO.CapeVerde,
  C239 = <any>CountryISO.SãoToméAndPríncipe,
  C240 = <any>CountryISO.EquatorialGuinea,
  C241 = <any>CountryISO.Gabon,
  C242 = <any>CountryISO.CongoRepublicCongoBrazzaville,
  C243 = <any>CountryISO.Congo,
  C244 = <any>CountryISO.Angola,
  C245 = <any>CountryISO.GuineaBissau,
  C246 = <any>CountryISO.BritishIndianOceanTerritory,
  C248 = <any>CountryISO.Seychelles,
  C249 = <any>CountryISO.Sudan,
  C250 = <any>CountryISO.Rwanda,
  C251 = <any>CountryISO.Ethiopia,
  C252 = <any>CountryISO.Somalia,
  C253 = <any>CountryISO.Djibouti,
  C254 = <any>CountryISO.Kenya,
  C255 = <any>CountryISO.Tanzania,
  C256 = <any>CountryISO.Uganda,
  C257 = <any>CountryISO.Burundi,
  C258 = <any>CountryISO.Mozambique,
  C260 = <any>CountryISO.Zambia,
  C261 = <any>CountryISO.Madagascar,
  C263 = <any>CountryISO.Zimbabwe,
  C264 = <any>CountryISO.Namibia,
  C265 = <any>CountryISO.Malawi,
  C266 = <any>CountryISO.Lesotho,
  C267 = <any>CountryISO.Botswana,
  C268 = <any>CountryISO.Swaziland,
  C269 = <any>CountryISO.Comoros,
  C27 = <any>CountryISO.SouthAfrica,
  C290 = <any>CountryISO.SaintHelena,
  C291 = <any>CountryISO.Eritrea,
  C297 = <any>CountryISO.Aruba,
  C298 = <any>CountryISO.FaroeIslands,
  C299 = <any>CountryISO.Greenland,
  C30 = <any>CountryISO.Greece,
  C31 = <any>CountryISO.Netherlands,
  C32 = <any>CountryISO.Belgium,
  C33 = <any>CountryISO.France,
  C34 = <any>CountryISO.Spain,
  C350 = <any>CountryISO.Gibraltar,
  C351 = <any>CountryISO.Portugal,
  C352 = <any>CountryISO.Luxembourg,
  C353 = <any>CountryISO.Ireland,
  C354 = <any>CountryISO.Iceland,
  C355 = <any>CountryISO.Albania,
  C356 = <any>CountryISO.Malta,
  C357 = <any>CountryISO.Cyprus,
  C358 = <any>CountryISO.Finland,
  C359 = <any>CountryISO.Bulgaria,
  C36 = <any>CountryISO.Hungary,
  C370 = <any>CountryISO.Lithuania,
  C371 = <any>CountryISO.Latvia,
  C372 = <any>CountryISO.Estonia,
  C373 = <any>CountryISO.Moldova,
  C374 = <any>CountryISO.Armenia,
  C375 = <any>CountryISO.Belarus,
  C376 = <any>CountryISO.Andorra,
  C377 = <any>CountryISO.Monaco,
  C378 = <any>CountryISO.SanMarino,
  C380 = <any>CountryISO.Ukraine,
  C381 = <any>CountryISO.Serbia,
  C382 = <any>CountryISO.Montenegro,
  C383 = <any>CountryISO.Kosovo,
  C385 = <any>CountryISO.Croatia,
  C386 = <any>CountryISO.Slovenia,
  C387 = <any>CountryISO.BosniaAndHerzegovina,
  C389 = <any>CountryISO.Macedonia,
  C39 = <any>CountryISO.Italy,
  C40 = <any>CountryISO.Romania,
  C41 = <any>CountryISO.Switzerland,
  C420 = <any>CountryISO.CzechRepublic,
  C421 = <any>CountryISO.Slovakia,
  C423 = <any>CountryISO.Liechtenstein,
  C43 = <any>CountryISO.Austria,
  C44 = <any>CountryISO.UnitedKingdom,
  C45 = <any>CountryISO.Denmark,
  C46 = <any>CountryISO.Sweden,
  C47 = <any>CountryISO.Norway,
  C48 = <any>CountryISO.Poland,
  C49 = <any>CountryISO.Germany,
  C501 = <any>CountryISO.Belize,
  C503 = <any>CountryISO.ElSalvador,
  C504 = <any>CountryISO.Honduras,
  C505 = <any>CountryISO.Nicaragua,
  C506 = <any>CountryISO.CostaRica,
  C507 = <any>CountryISO.Panama,
  C508 = <any>CountryISO.SaintPierreAndMiquelon,
  C509 = <any>CountryISO.Haiti,
  C53 = <any>CountryISO.Cuba,
  C58 = <any>CountryISO.Venezuela,
  C592 = <any>CountryISO.Guyana,
  C593 = <any>CountryISO.Ecuador,
  C594 = <any>CountryISO.FrenchGuiana,
  C596 = <any>CountryISO.Martinique,
  C597 = <any>CountryISO.Suriname,
  C598 = <any>CountryISO.Uruguay,
  C599 = <any>CountryISO.Curacao,
  C60 = <any>CountryISO.Malaysia,
  C61 = <any>CountryISO.Australia,
  C62 = <any>CountryISO.Indonesia,
  C63 = <any>CountryISO.Philippines,
  C64 = <any>CountryISO.NewZealand,
  C65 = <any>CountryISO.Singapore,
  C66 = <any>CountryISO.Thailand,
  C672 = <any>CountryISO.NorfolkIsland,
  C674 = <any>CountryISO.Nauru,
  C675 = <any>CountryISO.PapuaNewGuinea,
  C676 = <any>CountryISO.Tonga,
  C677 = <any>CountryISO.SolomonIslands,
  C678 = <any>CountryISO.Vanuatu,
  C679 = <any>CountryISO.Fiji,
  C680 = <any>CountryISO.Palau,
  C682 = <any>CountryISO.CookIslands,
  C683 = <any>CountryISO.Niue,
  C686 = <any>CountryISO.Kiribati,
  C687 = <any>CountryISO.NewCaledonia,
  C688 = <any>CountryISO.Tuvalu,
  C689 = <any>CountryISO.FrenchPolynesia,
  C690 = <any>CountryISO.Tokelau,
  C691 = <any>CountryISO.Micronesia,
  C692 = <any>CountryISO.MarshallIslands,
  C81 = <any>CountryISO.Japan,
  C852 = <any>CountryISO.HongKong,
  C853 = <any>CountryISO.Macau,
  C855 = <any>CountryISO.Cambodia,
  C86 = <any>CountryISO.China,
  C880 = <any>CountryISO.Bangladesh,
  C886 = <any>CountryISO.Taiwan,
  C90 = <any>CountryISO.Turkey,
  C91 = <any>CountryISO.India,
  C92 = <any>CountryISO.Pakistan,
  C93 = <any>CountryISO.Afghanistan,
  C94 = <any>CountryISO.SriLanka,
  C95 = <any>CountryISO.Myanmar,
  C960 = <any>CountryISO.Maldives,
  C961 = <any>CountryISO.Lebanon,
  C962 = <any>CountryISO.Jordan,
  C964 = <any>CountryISO.Iraq,
  C965 = <any>CountryISO.Kuwait,
  C966 = <any>CountryISO.SaudiArabia,
  C967 = <any>CountryISO.Yemen,
  C968 = <any>CountryISO.Oman,
  C971 = <any>CountryISO.UnitedArabEmirates,
  C972 = <any>CountryISO.Israel,
  C973 = <any>CountryISO.Bahrain,
  C974 = <any>CountryISO.Qatar,
  C975 = <any>CountryISO.Bhutan,
  C976 = <any>CountryISO.Mongolia,
  C977 = <any>CountryISO.Nepal,
  C98 = <any>CountryISO.Iran,
  C992 = <any>CountryISO.Tajikistan,
  C993 = <any>CountryISO.Turkmenistan,
  C994 = <any>CountryISO.Azerbaijan,
  C995 = <any>CountryISO.Georgia,
  C996 = <any>CountryISO.Kyrgyzstan,
  C998 = <any>CountryISO.Uzbekistan,

  C1264 = <any>CountryISO.Anguilla,  //Anguila
  C1268 = <any>CountryISO.AntiguaBarbuda,  //Antigua y Barbuda
  C1246 = <any>CountryISO.Barbados,  //Barbados
  C1441 = <any>CountryISO.Bermuda,  //Bermudas
  C1284 = <any>CountryISO.BritishVirginIslands,  //Islas Vírgenes Británicas
  C1345 = <any>CountryISO.CaymanIslands,  //Islas Caimán
  C1767 = <any>CountryISO.Dominica,  //Dominica
  C1809 = <any>CountryISO.DominicanRepublic,  //República Dominicana
  C1829 = <any>CountryISO.DominicanRepublic,  //República Dominicana
  C1849 = <any>CountryISO.DominicanRepublic,  //República Dominicana
  C1473 = <any>CountryISO.Grenada,  //Granada y Carriacou
  C1671 = <any>CountryISO.Guam,  //Guam
  C1876 = <any>CountryISO.Jamaica,  //Jamaica
  C1658 = <any>CountryISO.Jamaica,  //Jamaica
  C1664 = <any>CountryISO.Montserrat,  //Montserrat
  C1787 = <any>CountryISO.PuertoRico,  //Puerto Rico
  C1939 = <any>CountryISO.PuertoRico,  //Puerto Rico
  C1869 = <any>CountryISO.StKittsNevis,  //San Cristóbal y Nieves
  C1758 = <any>CountryISO.StLucia,  //Santa Lucía
  C1784 = <any>CountryISO.StVincentGrenadines,  //San Vicente y las Granadinas
  C1721 = <any>CountryISO.SintMaarten,  //Sint Maarten (parte holandesa)
  C1868 = <any>CountryISO.TrinidadTobago,  //Trinidad y Tobago
  C1649 = <any>CountryISO.TurksCaicos,  //Islas Turcas y Caicos
  C1340 = <any>CountryISO.USVirginIslands,  //Islas Vírgenes de los Estados Unidos
  C1670 = <any>CountryISO.NorthernMarianaIslands,  //Islas Marianas del Norte
  C1684 = <any>CountryISO.AmericanSamoa,
  C1 = <any>CountryISO.UnitedStates,
}
/**
 * 'C' in the key is equivalent to the acronym 'Country phone code'.
*/

export enum CountryPhoneDialCodeEnum {
  Argentina = '54',
  Bolivia = '591',
  Brazil = '55',
  Chile = '56',
  Colombia = '57',
  Guatemala = '502',
  Mexico = '52',
  Paraguay = '595',
  Peru = '51',
  UnitedStates = '1',
  Uruguay = '59',
}

export const countryPhoneDialCodesCa = {
  Canada: ['1242', '1416', '1514', '1204', '1226', '1236', '1249',
    '1250', '1252', '1254', '1256', '1260', '1262', '1264',
    '1267', '1270', '1289', '1306', '1343', '1403',
    '1431', '1437', '1438', '1439', '1440', '1450',
    '1506', '1519', '1581', '1587', '1588', '1604',
    '1613', '1639', '1647', '1705', '1709', '1778',
    '1780', '1807', '1819', '1825', '1844', '1867',
    '1902', '1905', '1906', '1907', '1908', '1909',
    '1912', '1913', '1914', '1916', '1918', '1925',
    '1928', '1930', '1935', '1937', '1949', '1954',
    '1978', '1980', '1985', '1987', '1992', '1365',
    '1418', '1548', '1579', '1672', '1742', '1782', '1873',]
};
